define('GoogleCaptcha.View', [
	'Backbone',
	'googlecaptcha.tpl'
], function GoogleCaptchaView(
	Backbone,
	recaptchaTpl
) {
	'use strict';

	return Backbone.View.extend({
		template: recaptchaTpl,
		title: 'GoogleCaptchaView',
		getContext: function getContext() {
			return {
				captchaAction: this.options.action
			};
		}
	});
});
